// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WfCVRQYdLysgZJxCmuwU{align-items:center;margin:0 -4px;display:flex}.WfCVRQYdLysgZJxCmuwU.gsvUoIuKkQyCwJ9RA1Og{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconAction": `WfCVRQYdLysgZJxCmuwU`,
	"hidden": `gsvUoIuKkQyCwJ9RA1Og`
};
export default ___CSS_LOADER_EXPORT___;
